import { POST, PUT, GET, DELETE, PATCH } from '../http';

export const Reservations = {
  Search: (spec) => {
    return POST('next/Reservation/Search', spec);
  },
  GetReservation: (id, spec) => {
    return GET('next/Reservation/GetReservation/' + id, spec);
  },
  CreateReservation: spec => {
    return POST('next/Reservation/CreateReservation', spec)
  },
  UpdateReservation: spec => {
    return PUT('next/Reservation/UpdateReservation', spec)
  },
  PatchReservation: spec => {
    return PATCH('next/Reservation/PatchReservation', spec, Object.getOwnPropertyNames(spec))
  },
  SearchArrivalAndGuestInHouse: (spec) => {
    return POST('next/Reservation/SearchArrivalAndGuestInHouse', spec);
  },
  GetReservationGroup: (spec) => {
    return POST('next/Reservation/GetGroupReservation', spec);
  }
};
export const Invoice = {
  GetTaxAuthorityApproval: (spec) => {
    return POST('next/Invoice/GetTaxAuthorityApproval', spec)
  },
  RemoveTaxAuthorityPendingTag: (spec) => {
    return POST('next/Invoice/RemoveTaxAuthorityPendingTag', spec)
  },
  GetInvoice: (spec) => {
    return GET('next/Invoice/GetInvoice', spec)
  },
  ProcessRefusedInvoiceTreatment: (spec) => {
    return POST('next/Invoice/TreatRefusedInvoice', spec)
  },
  GetTaxAuthorityInvoiceErrors: (spec) => {
    return GET('next/Invoice/GetTaxAuthorityInvoiceErrors', spec)
  },
    PostInvoice:(spec) => {
    return POST('next/Invoice/PostInvoice',spec)
  },
  PostTaxAuthorityError: (spec) => {
    return POST('next/Invoice/PostTaxAuthorityError', spec)
  }
}
export const Customers = {
  GetCustomers: (spec) => {
    return GET('next/Customer/GetCustomers', spec);
  },
}
export const CustomerGroups = {
  GetCustomerGroups: (spec) => {
    return GET('next/CustomerGroup/GetCustomerGroups', spec);
  },
  GetCustomersInGroup: (spec) => {
    return GET('next/CustomerGroup/GetCustomersInGroup', spec);
  },
  CreateOrUpdateCustomerGroup: (spec) => {
    return POST('next/CustomerGroup/CreateOrUpdateCustomerGroup', spec);
  },
}
export const PriceLists = {
  GetStatisticSources: (spec) => {
    return GET("next/PriceLists/GetStatisticSources", spec);
  },
  GetPriceGroups: (spec) => {
    return GET("next/PriceLists/GetPriceGroups", spec);
  },
  GetRatePerPersonPrices: (spec) => {
    return GET("next/PriceLists/GetRatePerPersonPrices", spec);
  },
  GetClassificationCategories: (spec) => {
    return GET("next/PriceLists/GetClassificationCategories", spec);
  },
  UpdatePricingElements: (spec) => {
    return POST("next/PriceLists/UpdatePricingElements", spec);
  },
  DeletePricingElements: (spec) => {
    return POST("next/PriceLists/DeletePricingElements", spec);
  },
  DeleteRatePricingElementPackages: (spec) => {
    return DELETE('next/PriceLists/DeleteRPEPackage', spec);
  },
  ValidateRateCopy: (spec) => {
	return GET('next/PriceLists/ValidateRateCopy', spec);
  },
}
export const AllocationAndStrategy = {
  GetAllocations: (spec) => {
    return POST("next/AllocationAndStrategy/GetAllocations", spec);
  },
  AddAllocation: (spec) => {
    return POST("next/AllocationAndStrategy/AddAllocation", spec);
  },
  UpdateAllocation: (spec) => {
    return PUT("next/AllocationAndStrategy/UpdateAllocation", spec)
  },
  UpdateAllocationDates: (spec) => {
    return POST("next/AllocationAndStrategy/UpdateAllocationDates", spec);
  },
  DeleteAllocations: (spec) => {
    return DELETE("next/AllocationAndStrategy/DeleteAllocations", spec);
  },
  GetAllocationWithDates: (spec) => {
    return GET("next/AllocationAndStrategy/GetAllocationsWithDates", spec);
  },
  GetStrategies: (spec) => {
    return GET("next/AllocationAndStrategy/GetStrategies", spec);
  },
  AddStrategy: (spec) => {
    return POST("next/AllocationAndStrategy/AddStrategy", spec);
  },
  AddStrategyAllocation: (spec) => {
    return POST("next/AllocationAndStrategy/AddStrategyAllocation", spec);
  },
  DeleteStrategy: (spec) => {
    return DELETE("next/AllocationAndStrategy/DeleteStrategy", spec);
  },
  GetAllocationEntities: (spec) => {
    return GET("next/AllocationAndStrategy/GetAllocationEntities", spec);
  },
  GetAvailableAllocations: (spec) => {
    return GET("next/AllocationAndStrategy/GetAvailableAllocations", spec);
  },
  AddEntitiesAndDeleteFromOtherAllocations: (spec) => {
    return POST("next/AllocationAndStrategy/AddEntitiesAndDeleteFromOtherAllocations", spec);
  },
  GetAllocationDateRanges: (spec) => {
    return GET("next/AllocationAndStrategy/GetAllocationDateRanges", spec);
  },
  AddAllocationDateRanges: (spec) => {
    return POST("next/AllocationAndStrategy/AddAllocationDateRanges", spec);
  }

}
export const ExtenalEntity = {
  GetExtenalEntityMapping: spec => {
    return POST("next/ExternalEntityMapping/GetExtenalEntityMapping", spec);
  },
  GetAllExtenalEntitiesIncludeMappings: spec => {
    return POST("next/ExternalEntityMapping/GetAllExtenalEntitiesIncludeMappings", spec);
  },
  PostExtenalEntityMapping: spec => {
    return POST("next/ExternalEntityMapping/PostExtenalEntityMapping", spec);
  }
}

export const Reports = {
  GetReports: (spec) => {
    return GET('next/Reports/GetReports', spec);
  },
  Housekeeping: (spec) => {
    return GET('next/Reports/Housekeeping', spec);
  },
  InvoicesReceiptsReport: (spec) => {
    return POST('next/Reports/InvoicesReceiptsReport', spec);
  },
  CustomerCommission: (spec) => {
    return POST("next/Reports/CustomerCommissionReport", spec);
  },
  ApartmentOwnersReport: (spec) => {
    return POST('next/Reports/ApartmentOwnersReport', spec);
  },
  GroupReservationsByCheckInDateReport: (spec) => {
    return POST('next/Reports/GroupReservationsByCheckInDateReport', spec);
  },
  TrialBalanceReport: spec => {
    return POST('next/Reports/TrialBalanceReport', spec);
  },
  GetOpenBalance: spec => {
    return GET('next/Reports/GetOpenBalance', spec);
  },
  GetReportEntities: () => {
    return GET('next/Reports/GetEntities')
  },
  RunReport: (spec) => {
    return POST('next/Reports/RunReport', spec);
  },
  GetReportDefinitions: () => {
    return GET('next/Reports/GetReportDefinitions')
  },
  RoomTypeFinalPrices: (spec) => {
    return GET('next/Reports/RoomTypeFinalPrices', spec);
  },
  FinalPricesByCombination: (spec) => {
    return GET('next/Reports/FinalPricesByCombination', spec);
  },
  AddonFinalPrices: (spec) => {
    return GET('next/Reports/AddonFinalPrices', spec)
  },
  GetReportDefinition: (id) => {
    return GET('next/Reports/GetReportDefinition/' + id)
  },
  DeleteReportDefinition: (id) => {
    return DELETE('next/Reports/DeleteReportDefinition', id)
  },
  CreateReportDefinition: (spec) => {
    return POST('next/Reports/CreateReportDefinition', spec)
  },
  UpdateReportDefinition: (spec) => {
    return PUT('next/Reports/UpdateReportDefinition', spec)
  }
};

export const Hotels = {
  GetHotels: (spec) => {
    return GET('next/Hotel/GetHotels', spec);
  },
};

export const Rooms = {
  GetRooms: (spec) => {
    return GET('next/Room/GetRooms', spec);
  },
  SetRoomHousekeepingStatus: (spec) => {
    return POST('next/Room/SetRoomHousekeepingStatus', spec);
  }
};
export const RoomTypes = {
  GetRoomTypes: (spec) => {
    return GET('next/RoomType/GetRoomTypes', spec);
  },
};

export const OverBooking = {
  GetOverBooking: (spec) => {
    return POST('next/OverBooking/GetOverBookings', spec);
  },
  UpdateOverBookings: (spec) => {
    return POST('next/OverBooking/UpdateOverBookings', spec);
  },
  GetRoomTypesAffectedByHotelLevel: (spec) => {
    return POST('next/OverBooking/GetRoomTypesAffectedByHotelLevel', spec);
  }
}

export const Addons = {
  GetHotelChainAddons: (spec) => {
    return GET('next/Addon/GetHotelChainAddons', spec);
  },
  GetExtraAddons: (spec) => {
    return GET('next/Addon/GetExtraAddons', spec);
  },
  GetHotelAddons: (spec) => {
    return GET('next/Addon/GetHotelAddons', spec);
  }
}

export const RoomTypeAddon = {
  GetRoomTypeAddon: (spec) => {
    return GET('next/Addon/GetRoomTypesAddon', spec);
  },
  UpdateRoomTypeAddons: (spec) => {
    return PUT('next/Addon/UpdateRoomTypeAddons', spec);
  },
  AddonPricedInNonAdddonRateCount: (spec) => {
    return GET('next/Addon/AddonPricedInNonAdddonRateCount', spec);
  }
}

export const Wings = {
  GetWings: (spec) => {
    return GET("next/Wing/GetWings", spec);
  }
}

export const Packages = {
  GetPackages: (spec) => {
    return GET("next/Package/GetPackages", spec);
  }
}

export const PackageGroup = {
  GetPackageGroups: (spec) => {
    return GET("next/PackageGroup/GetPackageGroups", spec);
  }
}

export const RoomExpenses = {
  GetRoomExpenses: (spec) => {
    return GET('next/RoomExpenses/GetRoomExpenses', spec);
  },
  AddRoomExpenses: (data) => {
    return POST('next/RoomExpenses/PostRoomExpenses', data);
  }
  ,
  UpdateRoomExpenses: (data) => {
    return PUT('next/RoomExpenses/UpdateRoomExpenses', data);
  },
  DeleteRoomExpenses: (data) => {
    return DELETE('next/RoomExpenses/DeleteRoomExpenses', data);
  }
};
export const RoomExpenseType = {
  GetRoomExpenseType: (spec) => {
    return GET('next/RoomExpenseType/GetRoomExpenseType', spec);

  },
};

export const Guests = {
  Search: (spec) => {
    return GET('next/Guest/Search', spec);
  },
  GetGuests: (spec) => {
    return GET('next/Guest/GetGuests', spec);
  },
  GetGuest: (id, spec) => {
    return GET('next/Guest/GetGuest/' + id, spec);
  },
  GetApartmentOwners: (spec) => {
    return GET('next/Guest/GetAppartmentOwners', spec);
  },
  CheckClubMember: (spec) => {
    return GET('next/Guest/CheckClubMember', spec)
  }
};
export const Clubs = {
  GetClubs: (spec) => {
    return GET('next/Club/GetClubs', spec)
  }
}
export const Rates = {
  GetRates: (spec) => {
    return GET('next/Rate/GetRates', spec);
  },
  GetRateCategories: (spec) => {
    return GET("next/RateCategory/GetRateCategories", spec);
  },
  GetRateDiscounts: (spec) => {
    return GET("next/Rate/GetRateDiscounts", spec);
  },
  GetRateDiscountAmounts: (spec) => {
    return POST("next/Rate/GetRateDiscountAmounts", spec);
  },
  SaveRateDiscounts: (spec) => {
    return POST("next/Rate/SaveRateDiscounts", spec);
  },
  DeleteRateDiscounts: (spec) => {
    return DELETE("next/Rate/DeleteRateDiscounts", spec);
  },
  DeactivateRateDiscounts: (spec) => {
    return DELETE("next/Rate/DeactivateRateDiscounts", spec);
  },
  SaveRateExcludedDates: (spec) => {
    return POST("next/Rate/SaveRateExcludedDates", spec);
  },
  GetRatePricingElements: (spec) => {
    return GET("next/Rate/GetRatePricingElements", spec);
  },
  PostRate: (rate) => {
    return POST('next/Rate/PostRate', rate);
  },
  PutRate: (rate) => {
    return PUT('next/Rate/PutRate', rate);
  },
  DeleteRateAssignments: (rate) => {
    return DELETE('next/Rate/DeleteRateAssignments', rate);
  },
  CopyRate: (spec) => {
    return POST('next/Rate/CopyRate', spec);
  },
};

export const Live = {
  GetLiveData: spec => {
    return POST('next/Live/GetLiveData', spec);
  },
  UpdatePrice: spec => {
    return POST('next/Live/UpdatePrice', spec);
  },
  RemoveManualRestrictions: spec => {
    return PUT('next/Live/RemoveManualRestrictions', spec);
  },
}
export const Calendar = {
  GetHotelDateParameters: (spec) => {
    return GET('next/Calendar/GetHotelDateParameters', spec);
  },
  GetReservations: (spec) => {
    return GET('next/Calendar/GetReservations', spec);
  },
  GetCustomerIcon: (id) => {
    return GET('next/Calendar/GetCustomerIcon/' + id);
  },
  GetYieldData: (spec) => {
    return GET('next/Calendar/GetYieldData', spec);
  },
  GetDateParameters: (spec) => {
    return GET('next/Calendar/GetDateParameters', spec);
  },
  GetAvailabilityData: (spec) => {
    return GET('next/Calendar/GetAvailabilityData', spec);
  },
};

export const Location = {
  GetLocation: (id) => {
    return GET('next/Location/GetLocation/' + id);
  }
}

export const RoomPlannedMaintenance = {
  GetRoomPlannedMaintenances: (spec) => {
    return GET('next/RoomPlannedMaintenance/GetRoomPlannedMaintenances', spec);
  },
  AddRoomPlannedMaintenances: (spec) => {
    return POST('next/RoomPlannedMaintenance/AddRoomPlannedMaintenances', spec);
  },
  UpdateRoomPlannedMaintenances: (spec) => {
    return PUT('next/RoomPlannedMaintenance/UpdateRoomPlannedMaintenances', spec);
  },
};

export const ReservationPolicy = {
  GetReservationPolicies: (spec) => {
    return GET('next/ReservationPolicy/GetReservationPolicies', spec);
  },
  AddReservationPolicies: (spec) => {
    return POST('next/ReservationPolicy/AddReservationPolicies', spec);
  },
  SaveReservationPolicy: (spec) => {
    return POST(
      'next/ReservationPolicy/SaveReservationPolicy',
      spec
    );
  },
  AddReservationPolicyExceptions: (spec) => {
    return POST(
      'next/ReservationPolicyException/AddReservationPolicyExceptions',
      spec
    );
  },
};

export const Settings = {
  GetEmailSettings: (spec) => {
    return GET('next/Settings/GetEmailSettings', spec)
  },
  PostEmailSettings: (spec) => {
    return POST('next/Settings/PostEmailSettings', spec)
  }
}

export const Tags = {
  GetTags: (spec) => {
    return GET('next/Tags/GetTags', spec);
  },
  AddTag: (spec) => {
    return POST('next/Tags/AddTag', spec);
  },
};

export const TagEntities = {
  GetGroupedTagEntities: (spec) => {
    return GET('next/TagEntities/GetGroupedTagEntities', spec);
  },
  GetFlatTagEntities: (spec) => {
    return GET(
      'next/TagEntities/GetFlatTagEntities',
      spec
    );
  },
  DeleteTagEntities: (ids) => {
    return DELETE(
      'next/TagEntities/DeleteTagEntities',
      ids
    );
  },
  CreateOrUpdateGroupedTagEntities: (spec) => {
    return POST(
      'next/TagEntities/CreateOrUpdateGroupedTagEntities',
      spec
    );
  },
  CreateTagEntities: (spec) => {
    return POST(
      'next/TagEntities/CreateTagEntities',
      spec
    );
  },
};

export const StaticDiscounts = {
  GetStaticDiscounts: (spec) => {
    return GET('next/StaticDiscount/GetStaticDiscounts', spec)
  },
}


export const Nationalities = {
  GetNationalities: (spec) => {
    return GET('next/Nationalities/GetNationalities', spec)
  },
}
export const Taxes = {
  CalculateTaxes: (spec) => {
    return POST('next/Taxes/CalculateTaxes/', spec)
  }
}

export const Products = {
  GetProducts: (spec) => {
    return GET('next/Product/GetProducts', spec);
  },
  Search: (spec) => {
    return GET('next/Product/Search', spec);
  },
  SearchWithoutLimits: (spec) => {
    return GET('next/Product/SearchWithoutLimits', spec);
  }
}

export const Print = {
  PrintReceipt: (id) => {
    return GET('next/Print/PrintReceipt/' + id)
  },
  PrintInvoice: (id, title) => {
    return GET('next/Print/PrintInvoice/' + id, { title })
  },
}

export const RMS = {
  GetRMSRules: spec => {
    return GET('next/RMS/GetRMSRules', spec)
  },
  PostRmsRules: (spec, data) => {
    return POST('next/RMS/PostRmsRules', data, null, spec)
  }
}
export const Folio = {
  GetPendingFoliosReport: (spec) => {
    return GET('next/Folio/GetPendingFoliosReport', spec)
  },
  GetTransactionRefundsDetails: (spec) => {
    return GET('next/Folio/GetTransactionRefundsDetails', spec)
  },
  Search: (spec) => {
    return POST('next/Folio/Search', spec);
  }
}
export const AccountingSystem = {
  GetAccountingSystemTypes: (spec) => {
    return GET('next/AccountingSystem/GetAccountingSystemTypes', spec)
  },
  GetOpenFormatLog: (spec) => {
    return GET('next/AccountingSystem/GetOpenFormatLog', spec)
  },
  GetHotelAccountingSystemTypes: (spec) => {
    return GET('next/AccountingSystem/GetHotelAccountingSystemTypes', spec)
  },
  GetTransactionCodeAccountingNumberMapping: (spec) => {
    return GET('next/AccountingSystem/GetTransactionCodeAccountingNumberMapping', spec)
  },
  PostTransactionCodeAccountingNumberMapping: (spec) => {
    return POST('next/AccountingSystem/PostTransactionCodeAccountingNumberMapping', spec)
  },
  PostPCNReport: (spec) => {
    return POST('next/AccountingSystem/PostPCNReport', spec)
  }
}
export const TransactionCode = {
  GetTransactionCode: (spec) => {
    return GET('next/TransactionCode/GetTransactionCode', spec)
  }
}
export const Menus = {
  GetUserMenus: () => {
    return GET('next/Menu/GetUserMenus')
  },
  FullContentSync: (spec) => {
    return POST("next/Menu/HandleFullContentSync", spec)
  }
}
export const Document = {
  GetDocumentType: (spec) => {
    return GET('next/DocumentSeries/GetDocumentType', spec)
  },
  GetDocumentSubType: (spec) => {
    return GET('next/DocumentSeries/GetDocumentSubType', spec)
  },
  GetDocumentSeries: (spec) => {
    return GET('next/DocumentSeries/GetDocumentSeries', spec)
  },
  PostDocumentSeries: (data) => {
    return POST('next/DocumentSeries/PostDocumentSeries', data)
  }
}

export const ETL = {
  GetAnalyticsURL: () => {
    return GET('next/ETL/GetAnalyticsURL')
  },
  Authenticate: (domain) => {
    return POST('next/ETL/Authenticate', domain)
  },
  GetAnalyticsUsers: spec => {
    return GET('next/ETL/GetAnalyticsUsers', spec)
  },
  SaveOrUpdateAnalyticsUsers: spec => {
    return POST('next/ETL/SaveOrUpdateAnalyticsUsers', spec)
  },
  GetHotels: spec => {
    return GET('next/ETL/GetHotels', spec)
  },
}

export const CurrencyExchange = {
  GetHotelCurrencyExchangeRates: spec => {
    return GET('next/CurrencyExchange/GetHotelCurrencyExchangeRates', spec)
  },
  UpdateHotelCurrencyExchangeRates: spec => {
    return POST('next/CurrencyExchange/UpdateHotelCurrencyExchangeRates', spec)
  }
}

export const Templates = {
  GetTemplates: (spec) => {
    return GET('next/Templates/GetTemplates', spec);
  },
};

export const ReceptionAnywhere = {
  GetCombinedRegistrationPdf: (spec) => {
    return POST('next/ReceptionAnywhere/GetCombinedRegistrationPdf', spec);
  },
};

export const TaxIdentity = {
  GetTaxIdentities: (spec) => {
    return GET('next/TaxIdentity/GetTaxIdentities', spec);
  },
  GetTaxIdentity: (spec) => {
    return GET('next/TaxIdentity/GetTaxIdentity', spec);
  },
  GetCreateOrEditTaxIdentityHotelOptions: (spec) => {
    return GET('next/TaxIdentity/GetCreateOrEditTaxIdentityHotelOptions', spec);
  },
  GetTaxAuthorityRegisterUrl: (spec) => {
    return GET('next/TaxIdentity/GetTaxAuthorityRegisterUrl', spec);
  },
  TaxAuthorityHealthCheck: (spec) => {
    return POST('next/TaxIdentity/TaxAuthorityHealthCheck', spec);
  },
  CreateOrUpdateTaxIdentity: (spec) => {
    return POST('next/TaxIdentity/CreateOrUpdateTaxIdentity', spec);
  }
};

export const Users = {
  GetUsers: (spec) => {
    return GET('next/User/GetUsers', spec);
  },
  GetDigitalCertificateData: (spec) => {
    return GET('next/User/GetDigitalCertificateData', spec);
  },
};

export const RateAssignment = {
  GetRateAssignments: (spec) => {
    return GET('next/RateAssignment/GetRateAssignments', spec);
  },
  GetAddRateAssignmentsOptions: (spec) => {
    return GET('next/RateAssignment/GetAddRateAssignmentsOptions', spec);
  },
  CreateMultipleRateAssignments: (spec) => {
    return POST('next/RateAssignment/CreateMultipleRateAssignments', spec);
  },
  CreateOrUpdateRateAssignments: (spec) => {
    return POST("next/RateAssignment/CreateOrUpdateRateAssignments", spec);
  },
  DeleteRateAssignments: (ids) => {
    return POST('next/RateAssignment/DeleteRateAssignments', ids);
  },
  DeleteCustomerGroupRateAssignments: (ids) => {
    return POST('next/RateAssignment/DeleteCustomerGroupRateAssignments', ids);
  },
};

export const RateDiscountExcludedEntities = {
  GetRateDiscountExcludedEntities: (spec) => {
    return GET('next/RateDiscountExcludedEntities/GetRateDiscountExcludedEntities', spec);
  },
  SaveRateDiscountExcludedEntities: (spec) => {
    return POST('next/RateDiscountExcludedEntities/SaveRateDiscountExcludedEntities', spec);
  },
  DeleteRateDiscountExcludedEntities: (spec) => {
    return DELETE('next/RateDiscountExcludedEntities/DeleteRateDiscountExcludedEntities', spec);
  },
};

export const Promotions = {
  GetPromotions: (spec) => {
    return GET('next/Promotion/GetPromotionsData', spec);
  },
  DeletePromotions: (spec) => {
    return DELETE('next/Promotion/DeletePromotions', spec);
  },
  GetHomeSitePromotion: (spec) => {
    return GET('next/Promotion/GetHomeSitePromotion', spec);
  },
  CreateOrUpdateHomeSitePromotion: (spec) => {
    return POST('next/Promotion/CreateOrUpdateHomeSitePromotion', spec);
  }
};

export const PricingTemplates = {
  GetPricingTemplates: (spec) => {
    return GET(
      'next/PricingTemplates/GetPricingTemplates',
      spec
    )
  },
  SavePricingTemplates: (spec) => {
    return POST(
      'next/PricingTemplates/SavePricingTemplates',
      spec
    );
  },
};

export const PricingTemplatesPrices = {
  GetPricingTemplatesPrices: (spec) => {
    return GET(
      'next/PricingTemplatesPrices/GetPricingTemplatesPrices',
      spec
    );
  },
  SavePricingTemplatesPrices: (spec) => {
    return POST(
      'next/PricingTemplatesPrices/SavePricingTemplatesPrices',
      spec
    );
  },
  DeletePricingTemplatesPrices: (spec) => {
    return DELETE(
      'next/PricingTemplatesPrices/DeletePricingTemplatesPrices',
      spec
    );
  },
};
export const Errors = {
  PostErrorRecording: (spec) => {
    return POST('next/Errors/PostErrorRecording', spec);
  }
}

export const RateCustomerCommissions = {
  GetRateCustomerCommissions: (spec) => {
    return GET('next/RateCustomerCommissions/GetRateCustomerCommissions', spec);
  },
  DeleteRateCustomerCommissions: (spec) => {
    return DELETE('next/RateCustomerCommissions/DeleteRateCustomerCommissions', spec);
  },
  CreateAndUpdateRateCustomerCommissions: (spec) => {
    return POST(
      'next/RateCustomerCommissions/CreateAndUpdateRateCustomerCommissions',
      spec
    );
  },
};

export const GenericFields = {
  GetGenericFieldsMappings: (spec) => {
    return GET('next/GenericFields/GetGenericFieldsMappings', spec);
  },
  GetGenericFields: (spec) => {
    return GET('next/GenericFields/GetGenericFields', spec);
  },
  GetGenericFieldsTranslations: (spec) => {
    return GET('next/GenericFields/GetGenericFieldsTranslations', spec);
  },
  GetGenericFieldsValues: (spec) => {
    return GET('next/GenericFields/GetGenericFieldsValues', spec);
  },
  SaveGenericFieldsMapping: (spec) => {
    return POST('next/GenericFields/SaveGenericFieldsMapping', spec);
  },
  PostGenericFields: (spec) => {
    return POST('next/GenericFields/PostGenericFields', spec);
  },
  PostGenericFieldsValues: (spec) => {
    return POST('next/GenericFields/PostGenericFieldsValues', spec);
  },
  SaveGenericFieldTranslations: (spec) => {
    return POST('next/GenericFields/SaveGenericFieldTranslations', spec);
  },
  DeleteGenericFieldsMappings: (spec) => {
    return DELETE('next/GenericFields/DeleteGenericFieldsMappings', spec);
  },
};
export const Monthly = {
  GetMonthlyData: spec => {
    return POST('next/Monthly/GetMonthlyData', spec);
  },
  // HS-70186: additive Monthly Grid flow - GetMonthlyData/GetMonthlyGrid are two
  // separate endpoints, gated server-side by MonthlyView:UseMonthlyGrid. See
  // src/pages/MonthlyView/monthlyFlow.js for the flag/fallback logic.
  GetMonthlySettings: () => {
    return GET('next/Monthly/GetSettings');
  },
  GetMonthlyGrid: spec => {
    return POST('next/Monthly/GetMonthlyGrid', spec);
  },
  GetMonthlyAllocations: spec => {
    return GET('next/Monthly/GetMonthlyAllocations', spec);
  }
}

export const OpenAI = {
  CreateNewThread: () => {
    return GET('next/Optimon/CreateNewThread');
  },
  GetThreadMessages: threadId => {
    return GET('next/Optimon/GetThreadMessages?threadId=' + threadId);
  },
  GetAssistantResult: spec => {
    return POST('next/Optimon/GetAssistantResult', spec);
  }
}

export const RoomClasses = {
  GetRoomClasses: (spec) => {
    return GET('next/RoomClass/GetRoomClasses', spec)
  },
  SaveRoomClass: (spec) => {
    return POST('next/RoomClass/SaveRoomClass', spec)
  }
}
export const LRV = {
  GetLrv: (spec) => {
    return POST('next/LRV/GetLrv', spec)
  },
  UpdateHurdleValue: (spec) => {
    return POST('next/LRV/UpdateHurdleValue', spec)
  },
  BulkUpdateLrv: (spec) => {
    return POST('next/LRV/BulkUpdateLrv', spec)
  }
}

export const RoomClassTypeMapping = {
  GetAvailableRoomTypes: (spec) => {
    return GET('next/RoomClassTypeMapping/GetAvailableRoomTypes', spec)
  },
  GetRoomTypesByRoomClassId: (spec) => {
    return GET('next/RoomClassTypeMapping/GetRoomTypesByRoomClassId', spec)
  },

}
export const Availability = {
  GetAvailability: (spec) => {
    // Clean RoomTypeIds to prevent validation error when clearing the dropdown
    const cleanedSpec = { ...spec };
    if (cleanedSpec.RoomTypeIds !== undefined && 
        (cleanedSpec.RoomTypeIds === '' || 
         (Array.isArray(cleanedSpec.RoomTypeIds) && cleanedSpec.RoomTypeIds.length === 0))) {
      delete cleanedSpec.RoomTypeIds;
    }
    return GET('next/Availability/GetAvailability', cleanedSpec);
  },
  UpdateMaxOccupancy: (spec) => {
    return PUT('next/Availability/UpdateMaxOccupancy', spec);
  },
  GetHotelLastAvailabilityDate: (spec) => {
    return GET('next/Availability/GetHotelLastAvailabilityDate', spec);
  }
}
export const HotelAddonInventory = {
  GetHotelAddonInventory: (spec) => {
    return GET('next/HotelAddonInventory/GetHotelAddonInventory', spec)
  },
  SaveHotelAddonInventory: (spec) => {
    return POST('next/HotelAddonInventory/SaveHotelAddonInventory', spec)
  },
  DeleteHotelAddonInventory: (spec) => {
    return DELETE('next/HotelAddonInventory/DeleteHotelAddonInventory', spec)
  }
}
export const RoomTypeAddonInventoryMapping = {
  GetRoomTypeAddonInventoryMapping: (spec) => {
    return GET('next/RoomTypeAddonInventoryMapping/GetRoomTypeAddonInventoryMapping', spec)
  },
  CreateRoomTypeAddonInventoryMapping: (spec) => {
    return POST('next/RoomTypeAddonInventoryMapping/CreateRoomTypeAddonInventoryMap', spec)
  }
}
export const HotelAddonAvailability = {
  GetHotelAddonAvailability: (spec) => {
    return GET('next/HotelAddonAvailability/GetHotelAddonAvailability', spec)
  },
  UpdateAvailability: (spec) => {
    return POST('next/HotelAddonAvailability/UpdateAvailability', spec)
  }
}
export const HotelDefaultReservationValues = {
  GetDefaultReservationValues: (spec) => {
    return GET('next/DefaultReservationValues/GetDefaultReservationValues', spec);
  },
  GetDefaultReservationProducts: (spec) => {
    return GET('next/DefaultReservationValues/GetDefaultReservationProducts', spec);
  },
  UpdateDefaultReservationValues: (spec) => {
    return POST('next/DefaultReservationValues/UpdateDefaultReservationValues', spec);
  },
  UpdateDefaultReservationProducts: (hotelId, spec) => {
    return POST('next/DefaultReservationValues/UpdateDefaultReservationProducts?HotelId=' + hotelId, spec);
  },
  UpdateAvailability: (spec) => {
    return POST('next/HotelAddonAvailability/UpdateAvailability', spec)
  }
}
export const Reasons = {
  GetReasons: (spec) => {
    return GET('next/Reason/GetReasons', spec);
  },
  SaveReasons: (reasons) => {
    return POST('next/Reason/SaveReasons', reasons);
  }
};

export const ReasonTypes = {
  GetReasonTypes: (spec) => {
    return GET('next/ReasonType/GetReasonTypes', spec);
  },
  SaveReasonType: (reasonType) => {
    return POST('next/ReasonType/SaveReasonType', reasonType);
  }
};

export const StatisticSources = {
  Search: (spec) => {
    return GET('next/StatisticSources/Search', spec);
  },
  SaveStatisticSources: (sources) => {
    return POST('next/StatisticSources/SaveStatisticSources', sources);
  },
};

export const PriceGroupsSettings = {
  Search: (spec) => {
    return GET('next/PriceGroup/Search', spec);
  },
  SavePriceGroups: (priceGroups) => {
    return POST('next/PriceGroup/SavePriceGroups', priceGroups);
  },
};

export const ClassificationCategories = {
  Search: (spec) => {
    return GET('next/ClassificationCategory/Search', spec);
  },
  SaveCategories: (categories) => {
    return POST('next/ClassificationCategory/SaveCategories', categories);
  },
};

export const HotelDateParameter = {
  BulkUpdate: (spec) => {
    return POST('next/HotelDateParameter/BulkUpdate', spec);
  },
  Search: (spec) => {
    return GET('next/HotelDateParameter/Search', spec);
  }
};
